import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BusinessProvider } from "./context/business-context";
import CartProvider  from "./context/CartContext/CartProvider";

import { QueryClient, QueryClientProvider} from 'react-query'
import { ToastProvider } from "./context/ToastContext";
const container = document.getElementById("root");
const root = createRoot(container!);
const query = new QueryClient();

root.render(
  <React.StrictMode>
    <BusinessProvider>
      <QueryClientProvider client={query}>
        <CartProvider>
 <ToastProvider>

   <App />
 </ToastProvider>
   
      </CartProvider>
      </QueryClientProvider>
    </BusinessProvider>
  </React.StrictMode>
);

// ✅ Register Service Worker (ONLY IN PRODUCTION)
/* if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(reg => console.log('✅ Service Worker registered:', reg))
      .catch(err => console.error('❌ Service Worker registration failed:', err));
  });
} */